import React, { useEffect, useState } from "react";
import './Button.scss'
const Button = ({ lecturaEscritura = 'E', children, width = '100%', onClick, className, disabled = false,style }) => {
    return (
        <>
            {
                disabled || lecturaEscritura == 'L' ?
                    <>
                        <div  className={`Button disabled ${className}`} style={{ width: width }}>{children}</div>
                    </>
                    :
                    <>
                        <button className={`Button ${className}`} onClick={onClick} style={{ width: width }}>{children}</button>
                    </>
            }
        </>
    )

}
export default Button